var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoadingText',{attrs:{"is-loading":_vm.getBalanceLoading === true || !!!_vm.balance,"loading-size":_vm.loadingSize,"loading-width":_vm.loadingWidth}},[_vm._v(" "+_vm._s(_vm._f("commaFormat")(_vm.slotText))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }